<!--行业对标（柱状图，多环形图）-->
<template>
  <div class="ib commonborder flex_row">
    <div class="left flex_column">
      <div id="ib_bar1" class="echarts"></div>
    </div>
    <div class="right">
      <div ref="ib_pie1" class="echarts"></div>
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
import api from '@/apis/power/power';
export default {
  data() {
    return {};
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //获取数据
    getList(){
      api.getBench().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          var t1 = _data.energyData
          var t2 = _data.monthData
          var t3 = _data.standardData
          var t4 = _data.tradeData
          var t5 = _data.countryData
          //对比
          var s1 = (_data.energyData/_data.monthData*100).toFixed(0)
          var s2 = (_data.energyData/_data.standardData*100).toFixed(0)
          var s3 = (_data.energyData/_data.tradeData*100).toFixed(0)
          var s4 = (_data.energyData/_data.countryData*100).toFixed(0)
          this.myfun(s1,s2,s3,s4)
          this.ib_bar1(t1,t2,t3,t4,t5)
        }
      })
    },
    myfun(a,b,c,d) {
      var chartDom = this.$refs.ib_pie1;
      var myChart = echarts.init(chartDom);
      var data = [
        {
          name: "月均对比",
          value: a,
          color:'#00f6ff'
        },
        {
          name: "企业对比",
          value: b,color:'#00f6ff'
        },
        {
          name: "行业对比",
          value: c,color:'#00f6ff'
        },
        {
          name: "国家对比",
          value: d,color:'#ff5f8c'
        },
      ];
      var titleArr = [];
      var seriesArr = [];
      data.forEach( (item, index) =>{

        titleArr.push({
          text: item.name,
          x: index%2 === 0 ?  29 + "%" :  69.5 + "%",
          y: index > 1 ? "84%" : "37%",
          textAlign: "center",
          textStyle: {
            fontWeight: "normal",
            fontSize: this.$echartsFontSize,
            color:'#ccd0f2',
            textAlign: "center",
          },
        });
        seriesArr.push({
          type: "pie",
          clockWise: false,
          radius: ['27%', '21.6%'],
          itemStyle: {
            normal: {
              color: item.color,
              shadowColor: item.color,
              shadowBlur: 0,
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          hoverAnimation: false,
          center: [
            index%2 === 0 ?  30 + "%" :  70 + "%",
            index > 1 ? "70%" : "22%",
          ],
          data: [
            {
              value: 100 - item.value,
              name: "invisible",
              itemStyle: {
                normal: {
                  color: '#0c2667',
                },
                emphasis: {
                  color: '#0c2667',
                },
              },
            },
            {
              value: item.value,
              label: {
                normal: {
                  formatter: function (params) {
                    return params.value + "%";
                  },
                  position: "center",
                  show: true,
                  textStyle: {
                    fontSize: this.$echartsFontSize+6,
                    fontWeight: "bold",
                    // color: colors[index][0],
                    color:'#fff'
                  },
                },
              },
            },
          ],
          markPoint: {
            data: [{
                symbol: 'triangle',
                symbolSize: this.$echartsFontSize-2,
                symbolRotate: item.color ==='#ff5f8c' ? 0 : 180,//剪头方向
                itemStyle: {
                    normal: {
                        color: item.color
                    }
                },
                x: index%2 === 0 ?  30 + "%" :  70 + "%",
                y: index > 1 ? "75%" : "27%",
                label: {
                    normal: {
                        show: false,
                    }
                },
            }]
          }


        });
      });
      var option = {
        title: titleArr,
        series: seriesArr,
      };
      // console.log(seriesArr)
      myChart.setOption(option);
    },
    ib_bar1(p1,p2,p3,p4,p5){
      let ib_bar1 = echarts.init( document.getElementById('ib_bar1') );
      ib_bar1.setOption({
          color:['#ffea04'],
          tooltip: { trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},},
          xAxis: {
              type: 'category',
              axisLabel:{color:this.axisLabelColor,rotate:25,fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
              data: ['实际能耗','企业标准', '行业标准', '国家标准'],
          },
          yAxis: {
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              splitLine:{lineStyle:this.splitLineStyle},
              splitNumber:3
          },
          grid: { left: '4%',right:'4%',top:'18%',bottom:'4%',containLabel: true},
          series: [
              {
                type: 'bar',
                barWidth:'20%',
                data: [p1,p3,p4,p5],
                label: {
                    show: true,
                    position: 'top',
                    textStyle:{ color:'#fff',fontSize:this.$echartsFontSize},
                    formatter: "{c}"+"tec",
                },
              } 
          ]
      })
    },
  },
  mounted() {
    this.getList()
    this.$nextTick(()=>{
      this.ib_bar1();
    })
  },
}
</script>

<style lang="less" scoped>
.ib {
  & > .left {
    width: 55%; height: 100%;overflow: hidden;
  }
  & > .right {
    width: 45%; height: 100%;overflow: hidden;
  }
}
</style>